import React from 'react'
import './App.css'
import { Backdrop, CircularProgress, Snackbar, Alert } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useSnackbar from './data/use-snackbar'
import Registration from './components/registration/registration.component'
import Home from './components/home.component'
import Portin from './components/portin/portin.component'
import Maintenance from './components/maintenance.component'
import M1AppBar from './components/layout/appbar.component'
import MaintenanceCheck from './components/layout/maintenancecheck.component'
import SetWhitelist from './components/layout/setwhitelist.component'
import Singpass from './components/singpass/app'
import { loadingState, toastState } from './components/helpers'

function App() {
  const toast = useRecoilValue(toastState)
  const loading = useRecoilValue(loadingState)
  const { handleClose } = useSnackbar()

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Router>
        <M1AppBar />
        <MaintenanceCheck />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/callback" element={<Home />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/portin" element={<Portin />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/whitelist" element={<SetWhitelist />} />
          <Route path="/callback/sp" element={<Singpass />} />
        </Routes>
      </Router>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={loading}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <Snackbar
        key={toast.key}
        open={toast.open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          onClose={handleClose}
          severity={toast.options?.variant || 'error'}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </LocalizationProvider>
  )
}

export default App
